import React,{useState} from 'react'
import KontakDiv from '../components/logo/KontakDiv'
import Navbar from '../components/Navbar/Index'
import Sidebar from '../components/Sidebar/Index'
import Portofolio from './home/portofolio/Portofolio'

const MyPorto = () => {
    const [isOpen,setOpen] = useState(false)
    const toggle = () => {
        setOpen(!isOpen)
    }
    return (
        <div>
            <KontakDiv/>
            <Sidebar isOpen={isOpen} toggle={toggle}/>
            <Navbar toggle={toggle}/>
            <Portofolio/>
        </div>
    )
}

export default MyPorto
